import { useGetParams } from "./hooks/useGetParams";

import defaultBackground from "./assets/images/bg.png";
import { useBroadcastPhoto } from "./hooks/useBroadcastPhoto";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Message from "./components/Message/Message";

function App() {
  const { currentState, showedMessages, isVisible } = useBroadcastPhoto();
  const { bg } = useGetParams();
  return (
    <TransitionGroup
      className="app-wrapper"
      style={{
        background: `url(${bg === "1" ? defaultBackground : bg}) center/cover no-repeat`,
      }}
    >
      {showedMessages.map((msg) => {
        return (
          <CSSTransition key={msg.UUID} timeout={2000} classNames="fade">
            <div className="message-wrapper">
              <Message message={msg.message} />
            </div>
          </CSSTransition>
        );
      })}

      <div id="img-loader"></div>
    </TransitionGroup>
  );
}

export default App;
